import { HttpClient } from '@angular/common/http';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  SimpleChanges
} from '@angular/core';
import { Platform } from '@ionic/angular';
import {
  LocationSuggestion,
  UserLocation
} from 'src/app/services/enode/enode.types';
import { hasChanged } from 'src/app/utils/change-utils';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
  @Input() locationSuggestions: LocationSuggestion[] = [];
  @Input() autoCompleteSuggestions: google.maps.places.PlaceResult = null;
  @Input() chargingLocation: UserLocation = null;
  @Output() emitSelectedLocation =
    new EventEmitter<google.maps.places.PlaceResult>();

  options: google.maps.MapOptions;
  circleOptions: google.maps.CircleOptions;
  markerPosition = new Set<google.maps.LatLngLiteral>();
  selectedLocation: google.maps.places.PlaceResult;
  selectedLocationLatLng: google.maps.LatLngLiteral;
  width: number;
  height: number;

  @ViewChild('placeSearch') inputField: ElementRef<HTMLInputElement>;
  constructor(_httpClient: HttpClient, private platform: Platform) {}

  ngOnInit() {
    if (this.platform.width() < 500) {
      this.height = this.width = this.platform.width() - 40;
    } else {
      this.height = this.width = 500;
    }
    this.circleOptions = {
      strokeColor: '#0a66ff',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#d6f2ff',
      fillOpacity: 0.35,
      radius: 200,
      clickable: true
    };

    const center = {
      lat:
        this.chargingLocation?.latitude ??
        this.locationSuggestions[0]?.latitude ??
        69.655263,
      lng:
        this.chargingLocation?.longitude ??
        this.locationSuggestions[0]?.longitude ??
        19.01119
    };

    this.options = {
      fullscreenControl: true,
      zoomControl: true,
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'satellite']
      },
      center,
      zoom: 15
    };
    if (this.locationSuggestions.length > 0) {
      this.locationSuggestions.forEach((suggestion) => {
        this.markerPosition.add({
          lat: suggestion.latitude,
          lng: suggestion.longitude
        });
      });
    } else {
      if (!this.chargingLocation) {
        // Fallback til kontoret om ingen lokasjonsforslag
        this.markerPosition.add({
          lat: 69.655263,
          lng: 19.01119
        });
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.autoCompleteSuggestions?.currentValue) {
      this.selectedLocation = changes.autoCompleteSuggestions.currentValue;
      this.selectedLocationLatLng =
        this.selectedLocation.geometry.location.toJSON();
      this.options = {
        center: this.selectedLocation.geometry.location.toJSON(),
        zoom: 17
      };
      this.emitSelectedLocation.emit(this.selectedLocation);
    }
  }

  mapClick(event: google.maps.MapMouseEvent) {
    if (this.chargingLocation) {
      return;
    }
    new google.maps.Geocoder().geocode(
      {
        location: event.latLng
      },
      (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          let place = results.find((result) => {
            if (result.types.includes('street_address')) {
              return result;
            } else if (result.types.includes('establishment')) {
              return result;
            }
          });
          this.selectedLocation = place;
          this.emitSelectedLocation.emit(this.selectedLocation);
        }
      }
    );
    this.options = {
      center: event.latLng.toJSON(),
      zoom: 17
    };
    this.selectedLocationLatLng = event.latLng.toJSON();
  }

  circleClick(event: any) {
    new google.maps.Geocoder().geocode(
      {
        location: event.latLng
      },
      (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          let place = results.find((result) => {
            if (result.types.includes('street_address')) {
              return result;
            } else if (result.types.includes('establishment')) {
              return result;
            }
          });
          this.selectedLocation = place;
          this.emitSelectedLocation.emit(this.selectedLocation);
        }
      }
    );
    this.options = {
      center: event.latLng.toJSON(),
      zoom: 17
    };
    this.selectedLocationLatLng = event.latLng.toJSON();
  }
}
